import brandLogoImg from "../../images/BrandLogo.png";

export default function BrandLogo() {
    return (<img src={brandLogoImg} style={{maxHeight: "50px", maxWidth: "140px"}} onError={(e) => e.target.style.display = 'none'}></img>)
}